import type { RouteObject } from "react-router";

import { routes } from "~/routes";

export function resourcesDriveRouteEntries(element: React.ReactNode): RouteObject[] {
  return [
    { path: routes.ResourcesDrive, element },
    { path: `${routes.ResourcesDrive}/:modelId/:revisionId?`, element },
    { path: `${routes.ResourcesDrive}/:modelId/:revisionId?/artifact/:artifactId/:artifactRevisionId?`, element },
    { path: routes.ResourcesDriveUnparentedArtifact, element },
  ];
}
